import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

interface ProjectCard {
  id: string;
  company: string;
  projectName: string;
  lastExecution: string;
  lastRequester: string;
  isFavorite: boolean;
  environment: string;
  name: string;
  badges: Array<{ name: string; svg: string; dataUrl: any; link: string }>;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectGuardService implements CanActivate, CanLoad {

  constructor(public router: Router) { }

  private isValidProject(projectName: string): boolean {
    try {
      const projectsJson = localStorage.getItem('projects');
      if (!projectsJson) {
        return false;
      }

      const projects: ProjectCard[] = JSON.parse(projectsJson);
      
      return projects.some(project => project.environment === projectName);
    } catch (error) {
      console.error('Erro ao validar projeto:', error);
      return false;
    }
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const projeto = route.params['projeto'];
    
    if (!projeto) {
      return this.router.createUrlTree(['/system-access']);
    }

    const isValid = this.isValidProject(projeto);
    
    if (!isValid) {
      return this.router.createUrlTree(['/system-access']);
    }

    return true;
  }

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    const projeto = segments[0]?.path;
    
    if (!projeto) {
      this.router.navigate(['/system-access']);
      return false;
    }

    const isValid = this.isValidProject(projeto);
    
    if (!isValid) {
      this.router.navigate(['/system-access']);
      return false;
    }

    return true;
  }
}

